/* @flow */
import * as React from 'react';
import PeopleListTableDataContainer from './PeopleListTableDataContainer.jsx';
import type { PeopleListFilterState } from './PeopleList.jsx';

type Props = {
  entityType: string,
  entityUuid: string,
  filters: PeopleListFilterState,
};

export default class PeopleListTable extends React.Component<Props> {
  render() {
    const { entityType, entityUuid, filters } = this.props;
    const { source, grade, role } = filters;

    const rosterFilterType = (() => {
      if (source && source.length === 1) {
        return source[0];
      } else {
        return 'all';
      }
    })();

    return (
      <div>
        {/* Table options will go here */}
        <PeopleListTableDataContainer
          entityType={entityType}
          entityUuid={entityUuid}
          grade={(grade && grade.enabled && grade.value) || null}
          query=""
          userRole={role}
          rostered={rosterFilterType}
        />
      </div>
    );
  }
}
